import React, { useState } from 'react';
import { GenPage, SegmentControl } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const PromoScript = () => {
  const t = useT();
  const [duration, setDuration] = useState('30s');

  return (
    <GenPage
      title={t('page.promoScript.title')}
      contentType="promoScript"
      description={t('page.promoScript.desc')}
      outputLabel={t('page.promoScript.output')}
      extraOptions={
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.duration')}</span>
          <SegmentControl
            options={['15s', '30s', '45s', '60s']}
            value={duration}
            onChange={setDuration}
          />
        </div>
      }
      extraInstructions={`Promo duration: ${duration}`}
    />
  );
};
